import PropTypes from 'prop-types';
import { useState } from 'react';
import {Link, useHistory} from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {Box, Divider, Grid, Tab, Tabs, Typography, AppBar, Toolbar} from '@mui/material';
import MainCard from '../../components/berry/ui-component/cards/MainCard';
import { gridSpacing } from 'store/appConstant';
import React from "react";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EmailIcon from '@mui/icons-material/Email';
import DefaultLayout from "../../components/layout/DefaultLayout";
import GestionsCookies from  "./GestionsCookies"
import Mentionslegales from "./Mentionslegales"
import ConditionsGenerales from "./ConditionsGenerales"
import ProtectionDonnees from "./ProtectionDonnees";
// tabs panel
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

// tabs option
const tabsOption = [
    {
        label: 'Gestions des cookies',
        icon: <AssignmentIndIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
        label: 'Mentions légales',
        icon: <EmailIcon sx={{ fontSize: '1.3rem' }} />
    },    {
        label: 'Conditions générales',
        icon: <AssignmentIndIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
        label: 'Protection des données personnelles',
        icon: <EmailIcon sx={{ fontSize: '1.3rem' }} />
    }
];

// ==============================|| PROFILE 1 ||============================== //

const Informationslegales = () => {
    const theme = useTheme();

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const history = useHistory();

    return (
        <DefaultLayout>
            <Box sx={{p: 2, bgcolor: 'transparent', borderRadius: '8px', width: '100%'}}>
                <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                    Informations légales
                </Typography>
                <Divider sx={{
                    borderColor: '#EF595D',
                    my: 1,
                    width: '8%',
                    borderWidth: '2px',
                    marginBottom: '15px',
                    marginTop: '15px'
                }} />
            </Box>
            <MainCard >
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12} >
                        <Tabs
                            value={value}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleChange}
                            aria-label="simple tabs example"
                            variant="scrollable"
                            sx={{
                                mb: 3,
                                '& a': {
                                    minHeight: 'auto',
                                    minWidth: 10,
                                    py: 1.5,
                                    px: 1,
                                    mr: 2.25,
                                    color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textTransform: 'none'
                                },
                                '& a.Mui-selected': {
                                    color: theme.palette.primary.main
                                },
                                '& .MuiTabs-indicator': {
                                    bottom: 2
                                },
                                '& a > svg': {
                                    marginBottom: '0px !important',
                                    mr: 1.25
                                }
                            }}
                        >
                            {tabsOption.map((tab, index) => (
                                <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
                            ))}
                        </Tabs>
                        <TabPanel value={value} index={0} >
                            <Grid container spacing={gridSpacing}>
                                <GestionsCookies />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Grid container spacing={gridSpacing}>
                                <Mentionslegales />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Grid container spacing={gridSpacing}>
                                <ConditionsGenerales />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <Grid container spacing={gridSpacing}>
                                <ProtectionDonnees/>
                            </Grid>
                        </TabPanel>
                    </Grid>
                </Grid>
            </MainCard>
        </DefaultLayout>
    );
};

export default Informationslegales;
